/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocationamount_Success2Inputs */

const en_coinvestments_allocationamount_success2 = /** @type {(inputs: Coinvestments_Allocationamount_Success2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation amount updated successfully`)
};

/**
* | output |
* | --- |
* | "Allocation amount updated successfully" |
*
* @param {Coinvestments_Allocationamount_Success2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocationamount_success2 = /** @type {((inputs?: Coinvestments_Allocationamount_Success2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocationamount_Success2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocationamount_success2(inputs)
});
export { coinvestments_allocationamount_success2 as "coInvestments_allocationAmount_success" }